// 数据统计
import $ from '../base'
import {
  WEATHER_BASE_URL,
  SN_BASE_URL,
  NV_BASE_URL,
  ACTIVITY_BASE_URL,
  JOB_BASE_URL,
  BOOK_BASE_URL,
  TOC_BASE_URL
} from '../../config/constants'

export default {
  //上传文件
  uploadFile: process.env.VUE_APP_BASE_URL + '/wnl/util/uploadFile',

  //获取应用市场分页数据列表
  getStorePage: $.post('crm/app/store/getStorePage'),
  //添加、编辑应用市场
  addOrEditStore: $.post('crm/app/store/addOrEdit'),
  //删除应用市场
  delStore: $.post('crm/app/store/delStore'),

  //获取app应用的分页数据
  getAppPage: $.post('crm/app/getAppPage'),

  //添加、编辑app应用
  addOrEditApp: $.post('crm/app/addOrEdit'),

  //获取app所有版本
  getAppVersion: $.post('crm/app/version/getAppVersion'),

  //添加、编辑app版本
  addOrEditVersion: $.post('crm/app/version/addOrEdit'),

  //删除版本
  delVersion: $.post('crm/app/version/delVersion'),

  //获取审核版本所有应用市场
  getVersionAllStore: $.post('crm/app/version/getVersionAllStore'),

  //app版本应用商店审核
  storeVersionCheck: $.post('crm/app/version/storeVersionCheck'),

  //获取功能外链分页数据
  getFuncsPage: $.post('crm/app/func/getAppFuncsPage'),

  //添加、编辑自有广告
  addOrEditFunc: $.post('crm/app/func/addOrEditFunc'),


  //获取广告商分页数据
  getAdvertSupplierPage: $.post('crm/advert/getAdvertSupplierPage'),

  //添加、编辑广告商
  addOrEditAdvertSupplier: $.post('crm/advert/addOrEditAdvertSupplier'),

  //获取广告商全部广告数据
  getSupplierAdvertPage: $.post('crm/advert/getSupplierAdvertPage'),

  //添加、编辑广告商广告
  addOrEditSupplierAdvert: $.post('crm/advert/addOrEditSupplierAdvert'),

  //删除广告商广告
  delSupplierAdvert: $.post('crm/advert/delSupplierAdvert'),

  //获取咨询供应商分页数据
  getNewsSupplierPage: $.post('crm/advert/getNewsSupplierPage'),

  //添加、编辑咨询商
  addOrEditNewsSupplier: $.post('crm/advert/addOrEditNewsSupplier'),

  //获取咨询商全部咨询分类选项数据
  getNewsSupplierOptions: $.post('crm/advert/getNewsSupplierOptions'),

  //添加、编辑咨询商咨询分类选项
  addOrEditNewsOption: $.post('crm/advert/addOrEditNewsOption'),

  //删除咨询选项
  delNewsOption: $.post('crm/advert/delNewsOption'),

  //获取自有广告分页数据
  getInnerAdvertPage: $.post('crm/advert/getInnerAdvertPage'),

  //添加、编辑自有广告
  addOrEditInnerAdvert: $.post('crm/advert/addOrEditInnerAdvert'),

  //获取app广告数据列表
  getAppAdverts: $.post('crm/advert/getAppAdverts'),

  //获取全部启用的应用市场列表
  getAllUsedStores: $.post('crm/app/store/getAllUsedStores'),

  //获取指定渠道添加app广告需要的数据
  getChannelAddAppAdvertNeedInfo: $.post('crm/advert/getChannelAddAppAdvertNeedInfo'),

  //获取指定渠道添加app广告需要的数据
  addOrEditAppAdvert: $.post('crm/advert/addOrEditAppAdvert'),

  //删除app广告数据
  delAppAdvert: $.post('crm/advert/delAppAdvert'),

  //复制app广告数据
  copyAppAdvert: $.post('crm/advert/copyAppAdvert'),

  //获取意见反馈分页数据
  getAdvicePage: $.post('crm/advice/getAdvicePage'),
  //导出app功能外链
  exportAppFuncs: $.link('crm/app/func/exportExcel'),
  //导出广告商广告excel
  exportSupplierAdvertExcel: $.link('crm/advert/exportSupplierAdvertExcel'),


  //获取神农提现待审核列表
  getSnCheckList: $.post(SN_BASE_URL + '/check/checkList'),
  //神农提现审核
  snCheckDraw: $.post(SN_BASE_URL + '/check/drawCheck'),

  //获取新看点提现待审核列表
  getNewVideoCheckList: $.post(NV_BASE_URL + '/check/checkList'),
  //新看点提现审核
  newVideoCheckDraw: $.post(NV_BASE_URL + '/check/drawCheck'),

  //获取所有一级分类
  getAllPageName: $.post('count/point/getAllPageName'),
  //获取所有一级分类
  getPageEventName: $.post('count/point/getPageEventName'),
  //获取一级分类统计数据
  getPageData: $.post('count/point/getPageData'),
  //获取二级分类统计数据
  getEventData: $.post('count/point/getEventData'),
  //导出一级分类统计数据
  exportPage: $.link('count/point/exportPage'),
  //导出二级分类统计数据
  exportEvent: $.link('count/point/exportEvent'),
  //获取广告统计数据
  getAdvertData: $.post('count/advert/getAdvertData'),


  //获取日期图片分页数据
  getDayPicPage: $.post('dayPic/getDayPicPage'),
  //添加、编辑日期图片
  addOrEditDayPic: $.post('dayPic/addOrEdit'),
  //删除日期图片
  delDayPic: $.post('dayPic/del'),

  //天气会员明细
  member: $.post(WEATHER_BASE_URL + '/user/detail'),

  //查询点灯配置分页列表
  lightPage: $.post(ACTIVITY_BASE_URL + 'crm/light/page'),
  //添加点灯配置
  addLight: $.post(ACTIVITY_BASE_URL + 'crm/light/add'),
  //启用/停用点灯配置
  updateLightStatus: $.post(ACTIVITY_BASE_URL + 'crm/light/updateLightStatus'),
  //获取点灯配置详情
  ligthDetail: $.detail(ACTIVITY_BASE_URL + 'crm/light'),
  //获取还愿金额配置
  getWishFee: $.get(ACTIVITY_BASE_URL + 'crm/light/wishFee'),
  //添加还愿金额配置
  addWishFee: $.post(ACTIVITY_BASE_URL + 'crm/light/addWishFee'),
  //获取引导配置
  getGuide: $.get(ACTIVITY_BASE_URL + 'crm/light/guide'),
  //添加还愿金额配置
  addGuide: $.post(ACTIVITY_BASE_URL + 'crm/light/addGuide'),
  //查询充值记录分页数据列表
  orderPage: $.post(ACTIVITY_BASE_URL + 'crm/light/orderPage'),
  //查询会员价格配置
  memberConfig: $.get(ACTIVITY_BASE_URL + 'crm/light/memberFee'),
  //会员价格设置
  addMemberFee: $.post(ACTIVITY_BASE_URL + 'crm/light/addMemberFee'),

  //兼职分页数据
  jobPage: $.post(JOB_BASE_URL + 'crm/jobPage'),
  //添加编辑兼职
  addOrEditJob: $.post(JOB_BASE_URL + 'crm/addOrEditJob'),
  //查询兼职详情
  jobDetail: $.detail(JOB_BASE_URL + 'crm/jobDetail'),
  //启用/停用兼职
  updateJobStatus: $.post(JOB_BASE_URL + 'crm/updateJobStatus'),
  //获取报名记录分页列表
  joinJobPage: $.post(JOB_BASE_URL + 'crm/joinJobPage'),
  //报名记录导出
  exportJoin: $.post(JOB_BASE_URL + 'crm/exportJoin'),
  //兼职猫岗位导出
  exportJob: $.post(JOB_BASE_URL + 'crm/exportJob'),
  //自营兼职推送日期设置
  jobPushDateSet: $.post(JOB_BASE_URL + 'crm/jobPushDateSet'),
  //获取app渠道开关配置
  getAppChannelSwitch: $.post(JOB_BASE_URL + 'crm/getAppChannelSwitch'),
  //设置app渠道开关配置
  appChannelSwitchConfig: $.post(JOB_BASE_URL + 'crm/appChannelSwitchConfig'),

  //校园直聘
  //查询校园招聘分页列表
  schoolJobPage: $.post(JOB_BASE_URL + 'crm/schoolJobPage'),
  //新增、编辑校园招聘
  addOrEditSchoolJob: $.post(JOB_BASE_URL + 'crm/addOrEditSchoolJob'),
  //启用/停用校园招聘
  updateSchoolJobStatus: $.post(JOB_BASE_URL + 'crm/updateSchoolJobStatus'),
  //查询校园招聘轮播图分页列表
  schoolJobImgPage: $.post(JOB_BASE_URL + 'crm/schoolJobImgPage'),
  //新增、编辑校园招聘轮播图
  addOrEditSchoolJobImg: $.post(JOB_BASE_URL + 'crm/addOrEditSchoolJobImg'),
  //启用/停用校园招聘轮播图
  updateSchoolJobImgStatus: $.post(JOB_BASE_URL + 'crm/updateSchoolJobImgStatus'),
  //查询校园招聘岗位分页列表
  schoolJobPostPage: $.post(JOB_BASE_URL + 'crm/schoolJobPostPage'),
  //新增、编辑校园招聘岗位
  addOrEditSchoolJobPost: $.post(JOB_BASE_URL + 'crm/addOrEditSchoolJobPost'),
  //启用/停用校园招聘岗位
  updateSchoolJobPostStatus: $.post(JOB_BASE_URL + 'crm/updateSchoolJobPostStatus'),
  //下载导入模板
  importTemplate: $.downloadExcel(JOB_BASE_URL + 'crm/importTemplate'),
  importCompany: JOB_BASE_URL + 'crm/importData',
  //广告图片管理
  jobAdvertImgPage: $.post(JOB_BASE_URL + 'crm/jobAdvertImgPage'),
  addOrEditAdvertImg: $.post(JOB_BASE_URL + 'crm/addOrEditAdvertImg'),
  updateAdvertImgStatus: $.post(JOB_BASE_URL + 'crm/updateAdvertImgStatus'),

  //获取所有自营待审核列表
  selfUnCheckJobPage: $.post(JOB_BASE_URL + 'crm/getCheckJobList'),
  selfJobCheck: $.post(JOB_BASE_URL + 'crm/checkJob'),
  addOrEditJobRecommand: $.post(JOB_BASE_URL + 'crm/jobRecommandAddOrEdit'),
  jobRecommandPage: $.post(JOB_BASE_URL + 'crm/jobRecommandPage'),
  jobRecommandDetail: $.detail(JOB_BASE_URL + 'crm/jobRecommandDetail'),
  jobRecommandRemove: $.post(JOB_BASE_URL + 'crm/jobRecommandRemove'),
  getCompanyList: $.post(JOB_BASE_URL + 'crm/getCompanyList'),
  checkCompany: $.post(JOB_BASE_URL + 'crm/checkCompany'),
  payList: $.post(JOB_BASE_URL + 'crm/payList'),

  pushMerchantPage: $.post(JOB_BASE_URL + 'crm/pushMerchantPage'),

  //数据统计
  addOrEditCountChannel: $.post(JOB_BASE_URL + 'crm/addOrEditCountChannel'),
  channelPage: $.post(JOB_BASE_URL + 'crm/channelPage'),
  allMainChannel: $.post(JOB_BASE_URL + 'crm/allMainChannel'),
  countChannelPage: $.post(JOB_BASE_URL + 'crm/countChannelPage'),
  allChildChannel: $.detail(JOB_BASE_URL + 'crm/allChildChannel'),


  //兼职直聘用户列表
  userInfoPage: $.post(JOB_BASE_URL + 'crm/userInfoPage'),
  updateUserTag: $.post(JOB_BASE_URL + 'crm/updateUserTag'),

  //导入兼职直聘自营岗位
  importSelfJob: JOB_BASE_URL + 'crm//selfJob/importData',
  importSelfJobTemplate: $.downloadExcel(JOB_BASE_URL + 'crm//selfJob/importTemplate'),


  //导入兼职直聘兼职猫数据
  importJob: JOB_BASE_URL + 'crm/job/importData',
  importJobTemplate: $.downloadExcel(JOB_BASE_URL + 'crm/job/importTemplate'),
  //兼职猫分页数据
  jobMaoPage: $.post(JOB_BASE_URL + 'crm/jobMaoPage'),
  //启用/停用兼职猫
  updateJobMaoStatus: $.post(JOB_BASE_URL + 'crm/updateJobMaoStatus'),
  //批量删除自营岗位
  batchRemoveSelfJob: $.post(JOB_BASE_URL + 'crm/batchRemove'),
  //青团岗位分类
  jobQingPage: $.post(JOB_BASE_URL + 'crm/jobQingPage'),
  exportQingJob: $.post(JOB_BASE_URL + 'crm/exportQingJob'),
  updateQingJobStatus: $.post(JOB_BASE_URL + 'crm/updateQingJobStatus'),
  qingJobSort: $.post(JOB_BASE_URL + 'crm/qingJobSort'),
  updateQingJobRemark: $.post(JOB_BASE_URL + 'crm/updateQingJobRemark'),
  drawRecord: $.post(JOB_BASE_URL + 'crm/drawRecord'),
  //查询分类列表
  bookTagePage: $.post(BOOK_BASE_URL + 'crm/book/page'),
  addOrEditTag: $.post(BOOK_BASE_URL + 'crm/book/add'),


  //banner分页
  bannerPage: $.post('crm/banner/page'),
  addOrEditBanner: $.post('crm/banner/add'),

  //获取一级岗位标签
  firstTag: $.post(JOB_BASE_URL + 'crm/dict/firstTag'),
  //获取二级岗位标签
  secondTag: $.post(JOB_BASE_URL + 'crm/dict/secondTag'),

  //校园直聘------------------------------
  //查询简历模板分页列表
  resumeTemplatePage: $.post(JOB_BASE_URL + 'crm/resumeTemplate/page'),
  //获取简历模板详情
  resumeTemplateDetail: $.detail(JOB_BASE_URL + 'crm/resumeTemplate'),
  //新增、编辑简历模板
  resumeTemplateAdd: $.post(JOB_BASE_URL + 'crm/resumeTemplate/add'),
  //查询会员套餐分页列表
  memberPage: $.post(JOB_BASE_URL + 'crm/member/page'),
  //新增、编辑会员套餐
  memberAdd: $.post(JOB_BASE_URL + 'crm/member/add'),
  //查询会员购买记录分页列表
  memberBuyPage: $.post(JOB_BASE_URL + 'crm/memberBuy/page'),
  //查询商品一级大类分页列表
  goodCatalogPage: $.post(JOB_BASE_URL + 'crm/goodCatalog/page'),
  //新增编辑商品一级大类
  goodCatalogAdd: $.post(JOB_BASE_URL + 'crm/goodCatalog/add'),
  //查询商品全部数据
  goodList: $.post(JOB_BASE_URL + 'crm/good/list'),
  //新增编辑商品
  goodAdd: $.post(JOB_BASE_URL + 'crm/good/add'),
  //查询我的已购商品一级大类分页列表
  goodBuyPage: $.post(JOB_BASE_URL + 'crm/goodBuy/page'),
  //更新用户状态
  updateUserStatus: $.post(JOB_BASE_URL + 'crm/updateUserStatus'),

  //兼职直聘-自营岗位列表里面的备注
  updateRemark: $.post(JOB_BASE_URL + 'crm/selfJobRemark'),
  //兼职直聘-自营岗位充值
  recharge: $.post(JOB_BASE_URL + 'crm/addSelfJobApplyNum'),
  //兼职直聘-自营岗位修改累计报名额度
  changeTotalLimit: $.post(JOB_BASE_URL + 'crm/editSelfJobTotalApplyNum'),


  //上传文件
  uploadFileToc: TOC_BASE_URL + 'union-job/job/businessPublic/upload/business-license',

  //获取岗位数据
  getJobData: $.post(TOC_BASE_URL + 'union-job/jobAll/jobPage'),
  //获取全部城市
  getAllCity: $.get(TOC_BASE_URL + 'union-job/jobAll/allCity'),
  //根据城市获取全部区县
  getAreaByCity: (city) => {
    return $.get(`${TOC_BASE_URL}union-job/jobAll/cityArea/${city}`)({})
  },
  //获取所有岗位类型
  getAllJobTypes: $.get(TOC_BASE_URL + 'job/jobInfo/allJobTab'),
  //获取薪资单位列表
  getSalaryUnitList: $.get(TOC_BASE_URL + 'union-job/job/businessPublic/getSalaryUnitList'),
  //获取岗位描述模板,一种示例写法,就是?拼接那种
  // getJdTemplate: (params) => {
  //   return $.get(TOC_BASE_URL + 'union-job/job/businessPublic/jobDescTemplate', params)
  // },
  //获取岗位描述模板
  getJobTemplate: (jobId) => {
    return $.get(`${TOC_BASE_URL}union-job/job/businessPublic/jobDescTemplate/${jobId}`)({})
  },
  //保存公司信息
  saveCompanyInfo: $.post(TOC_BASE_URL + 'union-job/job/businessPublic/submitBusinessInfo'),
  //获取 B 端用户填写的公司信息
  getCompanyInfo: $.get(TOC_BASE_URL + 'union-job/job/businessPublic/getBusinessCompanyInfo'),
  //保存岗位信息
  saveJobInfo: $.post(TOC_BASE_URL + 'union-job/job/businessPublic/saveBusinessPublishJob'),
  //获取 vip 档位信息
  getVipSelectInfo: $.get(TOC_BASE_URL + '/union-job/job/businessPublic/getAllVipInfo'),
  //获取购买报名量档位信息
  getBuyByCountInfo: $.get(TOC_BASE_URL + '/union-job/job/businessPublic/getApplyNumVipInfo'),
  //获取 B 端用户开通vip信息
  getVipInfo: $.get(TOC_BASE_URL + 'union-job/job/businessPublic/getCurrentUserVipInfos'),
  //岗位申请列表
  getApplyList: $.post(TOC_BASE_URL + 'union-job/job/businessPublic/joinBusinessJobPage'),
  //发布的职位列表
  getPostJobList: $.post(TOC_BASE_URL + 'union-job/job/businessPublic/getBusinessPublishJobList'),
  //获取岗位 id 获取岗位信息
  getBusinessPublishJob: (jobId) => {
    return $.get(`${TOC_BASE_URL}union-job/job/businessPublic/getBusinessPublishJob/${jobId}`)({})
  },
  //tob职位的上下线
  onlineOrOfflineBusinessPublishJob: $.post(TOC_BASE_URL + 'union-job/job/businessPublic/onlineOrOfflineBusinessPublishJob'),
  //将职位从待发布转为审核中
  pushBusinessPublishJobToCheck: (jobId) => {
    return $.get(`${TOC_BASE_URL}union-job/job/businessPublic/pushBusinessPublishJobToCheck/${jobId}`)({})
  },
  //生成pc端小程序登录码
  pcMpQrCode: $.post(TOC_BASE_URL + 'union-job/login/pcMpQrCode'),
  //获取pc扫码登录信息
  pcMpQrCodeLogin: $.get(TOC_BASE_URL + 'union-job/login/pcMpQrCodeLogin'),

}
